//@ts-nocheck

import _ from "lodash";

import {
  fullMiningType,
  fullSolType,
} from "dot/Components/Content/configurationArea/Business/system";
import { encodeBase64 } from "dot/Components/Logics/ensoCommonFunctions";
import {
  ROLE,
  STATUS,
  caseSubTypes,
  extensionOfferTools,
  mpwSegmentSolution,
  sCRMRegex,
  salesChannelLogic,
  toolRedirect,
} from "dot/Components/Misc/CaseDetails_System";
import OOT from "dot/Constants/services/oot";
import {
  changeAppState,
  resetAuth,
  setAccount,
  setError,
  showLoader,
  showModal,
  updateAccount,
  showBoqLoader
} from "Store/auth";
import { totalCost } from "Store/contentState/cartBoqSlice";
// import { resetCD, setData, setOBJ, setStatus } from "Store/contentState/caseDetails/caseDetailsSlice";
import {
  resetCD,
  setData,
  setOBJ,
  setStatus,
} from "Store/contentState/caseDetailsSlice";
// import { resetFC } from "Store/contentState/caseDetails/findCaseSlice";
import { resetFC, setRedirectModal } from "Store/contentState/findCaseSlice";
import { RootState, store } from "Store/mainStore";
import { setLive, setVisible } from "Store/general/theme";
import { generateSyncOfferItems, isHardwareSLAItem, applyPricing } from "dot/Utils";
import { getStateOfElement } from "./stateMachine/modules/CONFIG/configurator_statelogics";

import DATAMART_SERVICES from "dot/Constants/services/datamart_services";

import { setProp } from "Store/Actions";
import { redirectConfig } from "../Content/CaseDetailsPage/FindCase/utils/redirectConfig";


const CUSTOM_ACTIONS = {
  DEFAULT: 'default',
  MODIFIED: 'modified',
  DELETED: 'deleted',
  NEW_ITEM: 'new_item'
}

// Product/item type value for service-only items (as sent by the BoQ / OOT).
const PRODUCT_TYPE_SERVICE_ONLY = "serviceOnly";
/* LOGIC FOR SALES CHANNEL */

export const handleSalesChannelLogic = (state) => {
  //const state = store.getState();

  const selectedSalesChannel = state.caseDetails.data.sales_channel;

  if (selectedSalesChannel) {
    if (selectedSalesChannel === "DIR") {
      //  store.dispatch(setData({ key: 'endCustomer', value: state.caseDetails.data.account }))
      store.dispatch(
        setData({
          key: "endCustomer",
          value: state.caseDetails.data.endCustomer,
        })
      );
      store.dispatch(setData({ key: "distributor", value: "" }));
      store.dispatch(setData({ key: "resellers", value: "" }));
      store.dispatch(setData({ key: "indirect_resellers", value: "" }));
    }
    if (selectedSalesChannel === "DIS") {
      store.dispatch(
        setData({
          key: "endCustomer",
          value: state.caseDetails.data.endCustomer,
        })
      );
      store.dispatch(
        setData({ key: "distributor", value: state.caseDetails.data.account })
      );
      store.dispatch(setData({ key: "resellers", value: "" }));
      store.dispatch(
        setData({
          key: "indirect_resellers",
          value: state.caseDetails.data.indirect_resellers,
        })
      );
    }
    if (selectedSalesChannel === "RES") {
      store.dispatch(
        setData({
          key: "endCustomer",
          value: state.caseDetails.data.endCustomer,
        })
      );
      store.dispatch(setData({ key: "distributor", value: "" }));
      store.dispatch(
        setData({ key: "resellers", value: state.caseDetails.data.account })
      );
      store.dispatch(setData({ key: "indirect_resellers", value: "" }));
    }
    switch (state.caseDetails.data.sales_channel) {
      case selectedSalesChannel:
        store.dispatch(
          setVisible({
            id: salesChannelLogic[selectedSalesChannel].visible,
            value: true,
          })
        ); //stopped due to max stack error
        store.dispatch(
          setVisible({
            id: salesChannelLogic[selectedSalesChannel].hidden,
            value: false,
          })
        );
        break;
      default:
        break;
    }
    handleCaseDepSaleChannelLogic(state); //Makes fields R / O on the basis of casetype
  }
};

export const handleRestLogic = () => {
  store.dispatch(resetAuth());
  store.dispatch(resetFC());
  store.dispatch(resetCD());
};

export const handleAccountLogic = (oot_response, state) => {
  if (!oot_response.data.sales_channel.default) {
    return;
  }

  switch (oot_response.data.sales_channel.default) {
    case "DIR":
      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,
          account_id: oot_response.data.end_customer.account_id,
          type: "account",
        })
      );

      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,

          type: "end_customer",
        })
      );

      //set-the-fields
      store.dispatch(
        setOBJ({ path: "account", value: oot_response.data.end_customer.nid })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer",
          value: oot_response.data.end_customer.nid,
        })
      );

      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      break;
    case "RES":
      // alert('RES')
      store.dispatch(
        updateAccount({
          id: oot_response.data.reseller.nid,
          value: oot_response.data.reseller.name,
          account_id: oot_response.data.end_customer.account_id,
          type: "account",
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,

          type: "end_customer",
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.reseller.nid,
          value: oot_response.data.reseller.name,
          type: "resellers",
        })
      );

      store.dispatch(
        setOBJ({ path: "account", value: oot_response.data.reseller.nid })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer",
          value: oot_response.data.end_customer.nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_name",
          value: oot_response.data.end_customer.name,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      store.dispatch(
        setOBJ({ path: "resellers", value: oot_response.data.reseller.nid })
      );

      //set-the-fields

      break;
    case "DIS":
      store.dispatch(
        updateAccount({
          id: oot_response.data.distributor.nid,
          value: oot_response.data.distributor.name,
          account_id: oot_response.data.end_customer.account_id,
          type: "account",
        })
      );
      //   id: oot_response.data.distributor.nid,
      //   value: oot_response.data.distributor.name,
      //   type: "account",
      // },'result=>',store.getState().authSlice.system.account)
      store.dispatch(
        updateAccount({
          id: oot_response.data.distributor.nid,
          value: oot_response.data.distributor.name,
          type: "distributor",
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.end_customer.nid,
          value: oot_response.data.end_customer.name,

          type: "end_customer",
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer_account_nid",
          value: oot_response.data.end_customer.account_nid,
        })
      );
      store.dispatch(
        updateAccount({
          id: oot_response.data.indirect_reseller.nid,
          value: oot_response.data.indirect_reseller.name,
          type: "indirect_resellers",
        })
      );
      //set-the-fields
      store.dispatch(
        setOBJ({ path: "account", value: oot_response.data.distributor.nid })
      );
      store.dispatch(
        setOBJ({
          path: "distributor",
          value: oot_response.data.distributor.nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "endCustomer",
          value: oot_response.data.end_customer.nid,
        })
      );
      store.dispatch(
        setOBJ({
          path: "indirect_resellers",
          value: oot_response.data.indirect_reseller.nid,
        })
      );
      break;
    default:
      break;
  }
};

export const handleExceptionR6InternalLogic = (state) => {
  const currentState = store.getState();
  // Hardcoding the logic for Internal order case type as per the requirement.
  // Tradeoff: The if block will not turn in to true in case of the code for the case type Internal Order changes to any string other than 'internal_order'.
  if (
    currentState.findCase.data.caseType === "internal_order" &&
    currentState.authSlice.system.account.length > 0
  ) {
    store.dispatch(setData({ key: "sales_channel", value: "DIR" }));
    store.dispatch(
      setAccount(
        currentState.authSlice.system.account.filter((e) =>
          e?.value?.toLowerCase()?.includes("nokia")
        )
      )
    );
    return true; //if this logic is executing
  }
};

export const handleCaseDepSaleChannelLogic = (state) => {
  if (state.findCase.data.caseType === "frame_agreement") {
    var found = state.authSlice.system.currentState;
    var copyFound = Object.assign({}, found);
    let salesChannel = state.caseDetails.data.sales_channel;

    switch (salesChannel) {
      case "DIR":
        copyFound = {
          ...copyFound,
          fieldsRequired: { ...copyFound.fieldsRequired, endCustomer: true },
        };
        copyFound.fieldsRequired.distributor = false;
        copyFound.fieldsRequired.resellers = false;
        break;
      case "DIS":
        copyFound = {
          ...copyFound,
          fieldsRequired: { ...copyFound.fieldsRequired, endCustomer: false },
        };
        copyFound.fieldsRequired.distributor = true;
        copyFound.fieldsRequired.resellers = false;
        break;
      case "RES":
        copyFound = {
          ...copyFound,
          fieldsRequired: { ...copyFound.fieldsRequired, endCustomer: false },
        };
        copyFound.fieldsRequired.distributor = false;
        copyFound.fieldsRequired.resellers = true;
        break;
      default:
    }
    store.dispatch(changeAppState(copyFound));
  }
};

export const generateEOTRedirect = (redirect_uri) => {
  //step 1
  const dbName = toolRedirect.ENSO.dbName;
  const redirectURi = redirect_uri; //redirect.homePage;
  //step 2
  const encodedParams = encodeBase64(`${dbName}&redirect_uri=${redirectURi}`);
  //step 3
  const loginMSALAuth = `https://login.microsoftonline.com/${toolRedirect.ENSO.tenantID}/oauth2/v2.0/authorize?scope=User.Read&response_type=code&client_id=${toolRedirect.ENSO.clientID}&redirect_uri=${toolRedirect.ENSO.domain}/auth_oauth/microsoft&state=${encodedParams}`;
  return loginMSALAuth;
};

/**
 * handleRedirectOnCreate - Processes the redirect_target from the subTypeObj,
 * replacing placeholders with actual values from redirectConfig and validating the final URL.
 *
 * @param subTypeObj
 * @returns An object containing the processed URL and its validity status.
 */
export const handleRedirectOnCreate = (subTypeObj) => {
  // Destructure redirect_target from subTypeObj
  const { redirect_target } = subTypeObj;
  // Initialize redirect object
  const redirect = {
    url: "",
    isValid: false,
  };

  // Return early if no redirect_target provided
  if (!redirect_target) {
    return redirect;
  }

  // Replace all placeholders with actual values from redirectConfig
  let processedUrl = redirect_target;
  Object.keys(redirectConfig).forEach((key) => {
    if (processedUrl.includes(key)) {
      let value = redirectConfig[key];
      if (value) {
        // Remove trailing slash from the config value to prevent double slashes
        value = value.replace(/\/+$/, "");
        // Escape special regex characters in the key and replace all occurrences
        const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        processedUrl = processedUrl.replace(new RegExp(escapedKey, "g"), value);
      }
    }
  });

  // Validate the URL
  try {
    new URL(processedUrl);
    redirect.url = processedUrl;
    redirect.isValid = true;
  } catch (error) {
    console.warn("Invalid URL generated:", processedUrl, error);
    redirect.url = processedUrl;
    redirect.isValid = false;
  }
  return redirect;
};

/* LOGIC FOR REDIRECT TYPE */
export const handleRedirectType = (state: RootState) => {
  // const authSelector = state.authSlice;
  const caseDetailsSelector = state.caseDetails;
  const findCaseSelector = state.findCase;
  // const cartBoqSelector = state.cartBoq
  const businessSelector = state.business;

  try {
    var caseType = findCaseSelector.data.caseType;
    var subType = findCaseSelector.data.subType;
    var customerSegment = businessSelector.data.options.PTDAC.caseIndustry;
    var advanceFeatures = businessSelector.data.view.PTDAC.additionalFeature;
    if (Object.keys(caseSubTypes).includes(caseType)) {
      var caseTypeSubTypeKeysArray = caseSubTypes[caseType].map(
        (obj, caseIndex) => ({
          caseType: obj.types
            .map(
              (typeObj, index) =>
                typeObj.key === subType && { subType: typeObj.key, id: index }
            )
            .filter((z) => z !== false),
          caseIndex: caseIndex,
        })
      );
      var caseTypeSubTypeKeys = caseTypeSubTypeKeysArray
        .flatMap((z) => z)
        .filter((z) => z.caseType.length !== 0)[0];
      if (caseTypeSubTypeKeys) {
        //get the redirect type by reaching the node in caseSubTypes in system;
        var redirect = caseTypeSubTypeKeys
          ? caseSubTypes[caseType][caseTypeSubTypeKeys.caseIndex].redirect
          : null;
        if (subType === "help") {
          //If Redirect is not defined, user selects:
          if (mpwSegmentSolution.includes(customerSegment)) {
            //If Solution is "MPW-S", system sets Redirect = EnSo shop
            redirect = toolRedirect.ENSO;
          } else {
            //Solution is undefined:
            redirect = toolRedirect.OOT;
            if (advanceFeatures.length > 0) {
              //If any Advance features are needed, system sets Redirect = EnSo shop, otherwise, system sets Redirect = OOT
              redirect = toolRedirect.ENSO;
            }
          }
        }

        if (state.dynamic.data.reference_solution.solution === "MPW") {
          redirect = redirect = toolRedirect.OOT;
          return redirect;
        }

        if (redirect === null) {
          //If Redirect is not defined, user selects:

          if (
            caseDetailsSelector.data.extensionTool === extensionOfferTools.NDAC
          ) {
            //"Packaged Plug & Play as-a-service solution (NDAC)".(Renamed to - NDAC Compact) System sets Redirect = OOT.
            redirect = redirect = toolRedirect.OOT;
          }
          if (
            caseDetailsSelector.data.extensionTool ===
            extensionOfferTools.MPW_GSM
          ) {
            //"Packaged Plug & Play as-a-service solution (NDAC)".(Renamed to - NDAC Compact) System sets Redirect = OOT.
            redirect = redirect = toolRedirect.ENSO;
          }
        }
        return redirect;
      }
      if (caseTypeSubTypeKeys === undefined) {
        //handle no-subtype scenario - DEMAN/FRAME-agremments
        redirect = caseSubTypes[caseType][0].redirect;
        return redirect;
      }
    } else {
      store.dispatch(
        setError({
          key: "error",
          value:
            { errorCode: null, errorMsg: "Error Creating: Casetype & subtype must be selected" }
        })
      );
    }
  } catch (error) {
    store.dispatch(
      setError({
        key: "error",
        value: { errorMsg: error, errorCode: null },
      })
    );
  } finally {
  }
};

const getBoqForContainers = (
  data,
  dynamicList,
  boq_list,
  key,
  state,
  getListOfFields
) => {
  const containerFields = { ...data[1]["field_details"] };
  Object.entries(containerFields).forEach((data, _index) => {
    const perfield = dynamicList[key][data[1]["id"]];
    data[1]["type"] === "composite"
      ? getCompositeBoq(data, boq_list, state)
      : getBoqList(perfield, data, boq_list, state, getListOfFields);
  });
};

const getBoqForSubsteps = (
  data,
  dynamicList,
  boq_list,
  key,
  state,
  getListOfFields
) => {
  const containerFields = { ...data[1]["field_details"] };
  Object.entries(containerFields).forEach((data, _index) => {
    if (data[1]["type"] === "container") {
      getBoqForContainers(
        data,
        dynamicList,
        boq_list,
        key,
        state,
        getListOfFields
      );
    } else {
      //  if fields are outside of containers itself
      const perfield = dynamicList[key][data[1]["id"]];
      getBoqList(perfield, data, boq_list, state, getListOfFields);
    }
  });
};

export const getBoqOptions = (state, getListOfFields) => {
  let dynamicList = state.dynamic.data.element;
  let boq_list = {};
  const packagesList = state.config_stepper.data.solution_form_data.packages;

  if (packagesList && !_.isEmpty(dynamicList)) {
    Object.keys(packagesList).forEach(function (key) {
      const fieldDetails = packagesList[key].field_details;
      if (fieldDetails && !_.isEmpty(fieldDetails)) {
        Object.entries(fieldDetails).forEach((data, _index) => {
          //  if fields are inside a container
          if (data[1]["type"] === "container") {
            getBoqForContainers(
              data,
              dynamicList,
              boq_list,
              key,
              state,
              getListOfFields
            );
          } else if (
            data[1]["type"] === "details" ||
            data[1]["type"] === "fieldset"
          ) {
            // if the fields are inside the substeps / inside the tab view
            getBoqForSubsteps(
              data,
              dynamicList,
              boq_list,
              key,
              state,
              getListOfFields
            );
          } else {
            //  if fields are outside itself
            const perfield = dynamicList[key][data[1]["id"]];
            getBoqList(perfield, data, boq_list, state, getListOfFields);
          }
        });
      }
    });
  }
  return boq_list;
};

const getVisibilityOfElement = (data, state, getListOfFields) => {
  const allfieldData =
    getListOfFields && getListOfFields(state.dynamic.data.element);
  const allStates = getStateOfElement(data[1], allfieldData);
  return allStates;
};

const getModalData = (obj, key) => {
  if (_.has(obj, key)) {
    return _.get(obj, key);
  }
  return _.reduce(
    obj,
    (result, value) => {
      if (result) return result; // If found, return immediately
      if (_.isObject(value)) {
        return getModalData(value, key);
      }
      return result;
    },
    null
  );
};

const getCompositeBoq = (data, boq_list, state) => {
  let compositeKey = data[1]["form_callback"]["form_identifier"];
  compositeKey = compositeKey.replace(/-$/, "");
  const modalData = getModalData(state.dynamic.data.modal, compositeKey);
  // state.dynamic.data.modal[state.config_stepper.data.activeStep][state.config_stepper.data.activeSubStep][compositeKey];
  _.map(modalData, (eachData, key) => {
    _.map(eachData, (perfield, attr) => {
      // boq_list[data[1]['label']] = attr;
      const jkey = data[1]["label"] + "-" + key;
      if (!boq_list[jkey]) {
        boq_list[jkey] = {};
      }
      boq_list[jkey][attr] =
        perfield.value !== undefined ? perfield.value : perfield;
    });
  });
};

const getBoqList = (perfield, data, boq_list, state, getListOfFields) => {
  const visibileValue =
    data[1]["type"] === "hidden"
      ? "none"
      : getVisibilityOfElement(data, state, getListOfFields);
  if (perfield !== "" && visibileValue["visibility"] === "block") {
    if (data[1]["type"] === "checkbox" && data[1]["multiple"]) {
      if (_.isObject(perfield) && perfield["value"]) {
        boq_list[data[1]["label"]] = perfield["value"];
      } else if (_.some(perfield, "value")) {
        boq_list[data[1]["label"]] = perfield.map((item) => item.value);
      } else {
        boq_list[data[1]["label"]] = _.flatMap(perfield, (array) =>
          _.chain(array)
            .filter({ checked: true })
            .map((obj) => _.pick(obj, ["product_code", "quantity"]))
            .value()
        );
      }
    } else if (data[1]["type"] === "checkbox") {
      boq_list[data[1]["label"]] =
        typeof perfield !== "object"
          ? perfield.map((item) => item.value)
          : perfield.value;
    } else if (data[1]["type"] === "select" && data[1]["multiple"]) {
      boq_list[data[1]["label"]] = _.map(perfield, "value");
    } else if (data[1]["type"] === "radio" && typeof perfield === "object") {
      if (_.some(perfield, "value")) {
        boq_list[data[1]["label"]] = perfield.map((item) => item.value);
      } else if (perfield.value) {
        boq_list[data[1]["label"]] = perfield.value;
      } else {
        boq_list[data[1]["label"]] = _.flatMap(perfield, (array) =>
          _.chain(array)
            .filter({ checked: true })
            .map((obj) => _.pick(obj, ["product_code", "quantity"]))
            .value()
        );
      }
    } else {
      if (data[1]["type"] === "markup") {
        // as we have markup as notes for that check if label is there else make it blank
        //  as markup is for MXIE also it will conflict here
        if (perfield && _.isArray(perfield)) {
          boq_list[data[1]["label"]] = perfield.map((item) =>
            item.label ? { label: item.label, value: item.value } : ""
          );
        }
      } else {
        boq_list[data[1]["label"]] = perfield;
        if (perfield && _.has(perfield, "value")) {
          boq_list[data[1]["label"]] =
            perfield.value !== undefined ? perfield.value : null;
        }
      }
    }
  }
};

/**
 * Prepares a versioned Bill of Quantities (BoQ) by comparing the current cart items with the backup cart items.
 * If there are differences, it adjusts the quantities and includes any removed items with a quantity of zero.
 *
 * @param state - The current state of the Redux store.
 * @returns An array of cart items with versioned quantities.
 */
const prepareVersionedBoq = (
  saleItems,
  backupSaleItems,
  isDynamicBoq = false
) => {
  let boqItems = saleItems ? _.cloneDeep(saleItems) : [];

  let backupBoqItems = backupSaleItems ? _.cloneDeep(backupSaleItems) : [];

  // Variable defined but not used, can be removed if not needed in future
  // const boqItemsLength = _.isArray(boqItems)
  //   ? boqItems.length
  //   : _.keys(boqItems)?.length;
  const backupBoqItemsLength = _.isArray(backupBoqItems)
    ? backupBoqItems.length
    : _.keys(backupBoqItems)?.length;

  // UC 1 : If cartBakupItems is empty then there is no versioning done, In that case prevQuantity = null
  // if(cartBackupItems.length === 0) return cartItems;
  // UC 2: Add prevQuantity field for each cartItems with the quantity value from cartBakupItems
  _.map(boqItems, (eachItem) => {
    let backupItem;
    if (isDynamicBoq) {
      backupItem = _.find(backupBoqItems, (eachBackup_item) => eachBackup_item?.productCode === eachItem?.productCode && eachBackup_item?.quantity !== eachItem?.quantity && (eachBackup_item?.product_name ? eachBackup_item?.product_name : eachBackup_item?.work_item) === (eachItem?.product_name ? eachItem?.product_name : eachItem?.work_item));
    } else {
      backupItem = _.find(backupBoqItems, (eachBackup_item) => eachBackup_item?.product_id === eachItem.product_id && eachBackup_item.quantity !== eachItem.quantity && eachBackup_item.product_name === eachItem.product_name);
    }
    if (backupBoqItemsLength > 0 && backupItem) {
      eachItem['prevQuantity'] = backupItem.quantity;
      eachItem['prevEffort'] = backupItem.effort ?? backupItem.quantity;
      eachItem['customAction'] = CUSTOM_ACTIONS.MODIFIED; // modified action
    }
    else {
      eachItem['prevQuantity'] = null;
      eachItem['customAction'] = CUSTOM_ACTIONS.DEFAULT; // default action
    }
  });

  // UC 3: cartBackupItems.length !== cartItems.length && cartBackupItems.length > cartItems.length,
  // then there are some items removed from the cart
  // So add those items with quantity as 0
  let removedItems;
  if (isDynamicBoq) {
    removedItems = _.filter(backupBoqItems, (eachBackup_item) => !_.find(boqItems, (cartItem) => cartItem?.productCode === eachBackup_item?.productCode && cartItem?.work_item === eachBackup_item?.work_item));
  } else {
    removedItems = _.filter(backupBoqItems, (eachBackup_item) => !_.find(boqItems, (cartItem) => cartItem?.product_id === eachBackup_item?.product_id && cartItem?.product_name === eachBackup_item?.product_name));
  }
  if (removedItems) {
    _.map(removedItems, (eachItem) => {
      eachItem["quantity"] = 0;
      eachItem["prevQuantity"] = eachItem.quantity;
      eachItem["customAction"] = CUSTOM_ACTIONS.DELETED; // deleted action
      // set quantity and floor_price of item as 0 ( MPW items floor_price is sent as 0 for OOT to show their price as 0)
      if (eachItem?.floor_price) {
        eachItem['floor_price'] = 0;
      }
      if (eachItem?.pnp_with_incoterm) {
        eachItem['pnp_with_incoterm'] = 0;
        eachItem['total_pnp_with_incoterm'] = 0;
      }
      boqItems.push(eachItem);
    });
  }
  return boqItems;
};

const getMXIEVersionValue = (state: RootState, type: string) => {
  let mxieapiValue = state.dynamic?.data?.element?.review?.ddqf_flag_status?.key;
  const ddqf_required = state.dynamic?.data?.element?.review?.do_you_need_direct_delivery?.key;

  let mxieVersion = mxieapiValue;
  let mxieVersionNo = state.dynamic?.data?.element?.assumptions?.ddqf_flag_status_two?.key;
  if (_.toLower(ddqf_required) === 'no' && mxieVersionNo) {
    mxieVersion = mxieVersionNo;
  }

  return type === 'version' ? mxieVersion : ddqf_required ?? '';
}

const versionDynamicBoqItems = (state: RootState) => {
  let dynamicBoqItems =
    state.dynamic.data && state.dynamic.data.boq
      ? _.cloneDeep(state.dynamic.data.boq)
      : [];

  let dynamicBoqBackupItems = state?.dynamic?.data?.["dynamicboqBakup"]
    ? _.cloneDeep(state?.dynamic?.data?.["dynamicboqBakup"])
    : [];

  const allboqItems = prepareVersionedBoq(
    dynamicBoqItems,
    dynamicBoqBackupItems,
    true
  );
  return allboqItems;
};

export const checkValidCaseIndustry = (caseIndustry: string, isServiceOnlySubType: boolean) => {
  return (_.includes(['reference_solution', 'mining', 'manufacturing', 'port', 'oil', 'airport', 'mpw_network_with_no_existing_nda', 'mpw_network_with_existing_ndac'], caseIndustry) || isServiceOnlySubType === true);
}

// =============================================================================
// handleOffer helpers
// -----------------------------------------------------------------------------
// Logical decomposition of handleOffer. Each helper holds a verbatim slice of
// the original monolithic function body — code is moved, never modified.
// They communicate strictly via parameters / return values.
// =============================================================================

/**
 * prepareBoq — assembles all BoQ-related variables consumed by the offer
 * payload (configurator_mpw_list, protoType, mpwItems, versionedBoQ_cartItems,
 * contractDuration, isCustomized) and resolves lead_product. Holds the
 * MPW-specific BoQ filtering plus the duplicate "unconditional" MPW block
 * (kept as-is — pre-existing behavior).
 *
 * NOTE: `redirect` may be replaced in CONFIGURATION context via
 * identifyMPWRedirect; the (possibly updated) value is returned so callers
 * can use it downstream.
 */
const prepareBoq = (
  state: RootState,
  getListOfFields,
  context: string,
  initialRedirect: any,
  isServiceOnlySubType: boolean
) => {
  const findCaseSelector = state.findCase;
  const businessSelector = state.business;
  const cartBoqSelector = state.cartBoq;
  const cartTotal = totalCost(state.cartBoq);
  const configSelector = state.config_stepper;
  const dynamicSelector = state.dynamic;
  const solutionCategory = configSelector.data.solutionCategory;
  const solutionType = configSelector.data.solutionType;

  let redirect = initialRedirect;

  let contractDuration;
  let protoType = {};
  let config_mpw_params = {};
  // let mpw_additional_info = {};

  let configurator_mpw_list = {};
  let mpwItems = [];
  // Prepare whether the cart items is customised or not
  // old  comment - We can not use cartBoqSelector.data.isBoQEditable, there will be a drafted cart is also come in the future
  // let isCustomized = (state.cartBoq.data && state.cartBoq.data["cartBakup"] && state.cartBoq.data["cartBakup"]["items"] && state.cartBoq.data["cartBakup"]["items"].length > 0) ? true : false;

  // -------------- using the redux state isBoqEditable, as cartBackup will have the cart data when offer is created, it wont be empty, as we need the previous changes done on customise boq when we edit offer - check code for **customiseboq** --------------
  let isCustomized = cartBoqSelector?.data?.isBoQEditable;
  // Prepare the versionedBoQ from the redux state - compare with saved state and prepare the cart items
  let cartItems =
    state.cartBoq.data &&
      state.cartBoq.data.cart &&
      state.cartBoq.data.cart.items
      ? _.cloneDeep(state.cartBoq.data.cart.items)
      : [];

  let cartBackupItems =
    state.cartBoq.data &&
      state.cartBoq.data["cartBakup"] &&
      state.cartBoq.data["cartBakup"]["items"]
      ? _.cloneDeep(state.cartBoq.data["cartBakup"]["items"])
      : [];

  let versionedBoQ_cartItems = prepareVersionedBoq(
    cartItems,
    cartBackupItems,
    false
  );

  // MPW specific logic
  if (context === "CONFIGURATION") {
    // redirect to MPW when caseindustry is manufacturing/logistics and radio selected is MPW
    if (
      _.includes(
        ["logistics"],
        businessSelector.data.options.PTDAC.caseIndustry
      ) &&
      configSelector.data.solutionCategory === "MPW"
    ) {
      const changedRedirect = identifyMPWRedirect([
        configSelector.data.solutionCategory,
      ]).redirect;
      if (changedRedirect) {
        redirect = changedRedirect;
      }
    } else {
      if (
        businessSelector.data.options.PTDAC.caseIndustry === "port" &&
        configSelector.data.solutionCategory === "MPW"
      ) {
        const changedRedirect = identifyMPWRedirect([
          configSelector.data.solutionCategory,
        ]).redirect;
        if (changedRedirect) {
          redirect = changedRedirect;
        }
      }

      if (
        checkValidCaseIndustry(businessSelector.data.options.PTDAC.caseIndustry, isServiceOnlySubType)

      ) {
        // MPW list assembly (CONFIGURATION context) — see assembleMpwList.
        const mpw = assembleMpwList(
          state,
          getListOfFields,
          configSelector,
          dynamicSelector,
          solutionCategory,
          solutionType,
          versionedBoQ_cartItems
        );
        config_mpw_params = mpw.config_mpw_params;
        configurator_mpw_list = mpw.configurator_mpw_list;
        mpwItems = mpw.mpwItems;
        // re-filtered here for MPW, non-Standalone solutions; NDAC assembly uses it.
        versionedBoQ_cartItems = mpw.versionedBoQ_cartItems;
      }
      if (checkValidCaseIndustry(businessSelector.data.options.PTDAC.caseIndustry, isServiceOnlySubType) &&
        configSelector.data.solution_selected !== "cmu" &&
        redirect.id !== "ENSO"
      ) {
        // NDAC sync-offer assembly (CONFIGURATION context) — see assembleNdacProtoType.
        const ndac = assembleNdacProtoType(
          cartBoqSelector,
          dynamicSelector,
          businessSelector,
          versionedBoQ_cartItems,
          cartTotal
        );
        protoType = ndac.protoType;
        contractDuration = ndac.contractDuration;
      }
    }
  }

  const caseTypeList = findCaseSelector?.caseList?.data || [];
  let lead_product = "NDAC";

  try {
    const matchedCaseType = caseTypeList.find(
      (config) => config?.code?.toLowerCase() === findCaseSelector?.data?.caseType?.toLowerCase()
    );
    const matchedSubType = matchedCaseType?.sub_types?.find(
      (subtype) => subtype?.code?.toLowerCase() === findCaseSelector?.data?.subType?.toLowerCase());
    lead_product = matchedSubType?.lead_product || "NDAC";
  } catch (error) {
    dispatch(setError({
      key: "error",
      value: { errorCode: null, errorMsg: "Error in fetching lead product, defaulting to NDAC." },
    }));
    throw error;
  }

  if (checkValidCaseIndustry(businessSelector.data.options.PTDAC.caseIndustry, isServiceOnlySubType)) {
    // MPW list assembly (runs for all contexts) — see assembleMpwList.
    const mpw = assembleMpwList(state, getListOfFields, configSelector, dynamicSelector, solutionCategory, solutionType, versionedBoQ_cartItems);
    config_mpw_params = mpw.config_mpw_params;
    configurator_mpw_list = mpw.configurator_mpw_list;
    mpwItems = mpw.mpwItems;
    // re-filtered here for MPW, non-Standalone solutions; NDAC assembly uses it.
    versionedBoQ_cartItems = mpw.versionedBoQ_cartItems;
  }
  if (checkValidCaseIndustry(businessSelector.data.options.PTDAC.caseIndustry, isServiceOnlySubType) && configSelector.data.solution_selected !== 'cmu' && redirect.id != "ENSO") {
    // NDAC sync-offer assembly (runs for all contexts) — see assembleNdacProtoType.
    const ndac = assembleNdacProtoType(cartBoqSelector, dynamicSelector, businessSelector, versionedBoQ_cartItems, cartTotal);
    protoType = ndac.protoType;
    contractDuration = ndac.contractDuration;
  }

  return {
    redirect,
    config_mpw_params,
    configurator_mpw_list,
    protoType,
    mpwItems,
    versionedBoQ_cartItems,
    contractDuration,
    isCustomized,
    lead_product,
  };
};

// called for serviceonly items to send items in services section to oot -- send only MPS items from serviceonly to servcies section
const filterServiceOnlyItems = (items: any[]) => {
  return items.filter((e) =>  e?.type === PRODUCT_TYPE_SERVICE_ONLY && e?.productFamily === "MPS");
}

// =============================================================================
// MPW / NDAC offer-payload assembly helpers
// -----------------------------------------------------------------------------
// These two functions hold the (previously duplicated) logic used to build the
// offer payload for the two solution families:
//   - assembleMpwList        -> the MPW configurator list (config_mpw_params +
//                               configurator_mpw_list + the MPW/NDAC BoQ split)
//   - assembleNdacProtoType  -> the NDAC sync-offer protoType (services + boq +
//                               das + serviceOnly + SLA/warranty premium add-ons)
// They are pure w.r.t. `prepareBoq`: everything goes in via parameters and out
// via the returned object, so both the CONFIGURATION-context call site and the
// unconditional call site can reuse them.
// =============================================================================

/**
 * assembleMpwList — builds the MPW configurator payload from the current BoQ.
 *
 * For MPW, non-Standalone solutions it splits the versioned BoQ into MPW items
 * (`mpwItems`) vs. the remaining NDAC cart items (returned as the updated
 * `versionedBoQ_cartItems`), then assembles `configurator_mpw_list`
 * (items + partner_accredits + dod_applicable + incoterm + boq_options).
 *
 * @returns { config_mpw_params, configurator_mpw_list, mpwItems, versionedBoQ_cartItems }
 *          — the caller must re-assign `versionedBoQ_cartItems` from the result
 *          because it may have been re-filtered here (the NDAC assembly relies on it).
 */
export const assembleMpwList = (
  state: RootState,
  getListOfFields: any,
  configSelector: any,
  dynamicSelector: any,
  solutionCategory: any,
  solutionType: any,
  versionedBoQ_cartItems: any[]
) => {
  const datesData = getDateCalculated();
  const config_mpw_params = {
    "segment": configSelector.data.solution_selected === 'cmu' ? "ug" : "",
    "estimated_order_date": datesData.final_est_order_date,
    "requested_deli_date": datesData.final_req_delivery_date,
    "nature_of_order": "Sales order",
    "network_details": "Not related to NDAC network",
    // Removed the case details summary as it is not relevant
    // caseDetailsSelector.data.summary && caseDetailsSelector.data.summary !== "" ? caseDetailsSelector.data.summary : "Offer",
  };
  // let allboqItems = _.cloneDeep(state.dynamic.data.boq);
  let allboqItems = versionDynamicBoqItems(state);
  let mpwItems: any[] = [];

  // check here
  if (solutionCategory === 'MPW' && solutionType !== 'Standalone') {
    // update the type from UI cart boq into original boq , as we need that for differenciating mpw and ndac items
    _.map(allboqItems, (eachItem) => {
      if (eachItem.type === "") {
        const saleItemFound = _.filter(versionedBoQ_cartItems, (uiboqItem) => uiboqItem.product_id === eachItem.productCode && (uiboqItem?.financialProduct ?? uiboqItem?.financial_product) === eachItem.financial_product && uiboqItem.work_package === eachItem.work_package);
        if (saleItemFound && saleItemFound.length > 0) {
          eachItem['type'] = saleItemFound[0].type;
        }
      }
    });
    // when solution is mpw we want to divide the cart boq based on type
    mpwItems = _.filter(allboqItems, (e) => {
      const prodId = e.productCode || e.si_code;
      const prodType = e.type || "";
      const financialSalesType = e.financialSalesType || "";

      const isMPWType = _.includes(['hardware', 'software', 'end_end_services', 'product_attached_services', 'care', 'srs', 'custom_add_service', 'custom_add_product', 'serviceonly'], (prodType).toLowerCase()); // && financialSalesType !== ""
      const isPSND = _.includes(prodId, 'PSND');
      const isEmptyType = prodType === "" ? true : false;

      return ((isMPWType && !isPSND) || isEmptyType);
    });
    // all items other than mpw items add in boq for ndac items
    versionedBoQ_cartItems = _.filter(allboqItems, (obj1) => {
      // Delete the si_code from the object if it is MXIE product
      // Any si_code starting with 'SKNDEDGN' should be removed
      if (obj1?.si_code && obj1.si_code.startsWith('SKNDEDGN')) {
        delete obj1.si_code;
      }
      const hasSiCode = obj1.hasOwnProperty('si_code');
      const hasMatchingProductCode = mpwItems.some(obj2 => obj1.hasOwnProperty('productCode') && obj1.productCode !== obj2.productCode);

      return !hasSiCode && hasMatchingProductCode;
    });
  }
  // also remove the items in mpwItems that are in versionedBoQ_cartItems
  mpwItems = mpwItems.filter((item) => !versionedBoQ_cartItems.some((cartItem) => (cartItem.si_code || cartItem.productCode) === (item.si_code || item.productCode)));

  const configurator_mpw_list: any = {
    items: ((configSelector.data.solution_selected === 'cmu' || configSelector.data.solution_selected === 'evc') ? allboqItems : (mpwItems.length > 0 ? mpwItems : [])),
    partner_accredits: (dynamicSelector?.data?.boq && dynamicSelector?.data?.boq[0] && dynamicSelector.data.boq[0].partner_accredits) ? dynamicSelector.data.boq[0].partner_accredits : "",
    dod_applicable: (dynamicSelector.data.boq && dynamicSelector.data.boq[0] && dynamicSelector.data.boq[0].dod_applicable) ? dynamicSelector.data.boq[0].dod_applicable : "",
    incoterm: "",
    boq_options: getBoqOptions(state, getListOfFields) // this has been complicated , we can make another dataset with values when add to cart and use it here
  };
  // send package count value from redux in boq_options, for MPW soln there will be value count , in case of NDAC send it as 1
  configurator_mpw_list['boq_options']['package_options_count'] = dynamicSelector.data?.package_options_count ? dynamicSelector.data.package_options_count : 1;

  return { config_mpw_params, configurator_mpw_list, mpwItems, versionedBoQ_cartItems };
};

/**
 * assembleNdacProtoType — builds the NDAC sync-offer `protoType`.
 *
 * Collects service items, DAS items and service-only items from the cart, maps
 * them via generateSyncOfferItems, adds the SLA/warranty premium add-ons and
 * resolves the contract duration from the reference solution.
 *
 * @returns { protoType, contractDuration }
 */
export const assembleNdacProtoType = (
  cartBoqSelector: any,
  dynamicSelector: any,
  businessSelector: any,
  versionedBoQ_cartItems: any[],
  cartTotal: any
) => {
  const slaWarrantyProds = ndac_fetchSlaWarrantyProducts(cartBoqSelector, dynamicSelector, businessSelector, versionedBoQ_cartItems);
  const contractDuration = dynamicSelector?.data?.reference_solution?.contract_duration;
  const serviceItems = cartBoqSelector?.data?.cart.items.filter((e) => e.type === "end_end_services" || e.type === "custom_add_service" || (e?.cui_type === "service"));
  // filter das items only from cart boq items
  const dasItems = cartBoqSelector?.data?.cart.items.filter((e) => e.financialProduct === "DAS_Pricing");
  const protoType: any = {
    "services": generateSyncOfferItems('services', serviceItems, contractDuration, dynamicSelector),
    "boq": generateSyncOfferItems('ndac', versionedBoQ_cartItems, undefined, dynamicSelector),
    "type": 'ndac',
    "total_prod_cost": cartTotal,
    "ndac_premium_addons": slaWarrantyProds
  };
  protoType['services'] = [...protoType['services'], ...generateSyncOfferItems('das', dasItems, contractDuration, dynamicSelector)];
  const serviceOnlyItems = filterServiceOnlyItems(cartBoqSelector?.data?.cart.items);
  protoType['services'] = [...protoType['services'], ...generateSyncOfferItems(PRODUCT_TYPE_SERVICE_ONLY, serviceOnlyItems, contractDuration, dynamicSelector)];

  return { protoType, contractDuration };
};

/**
 * buildProfitabilityItemsFromState — segregates the cart BoQ of a saved offer
 * (reconstructed from its `ui_json` redux snapshot) into the item buckets sent
 * to /v2/pricing/profitability.
 *
 * Reuses assembleMpwList / assembleNdacProtoType so classification matches the
 * sync-offer flow. `solutionCategory` / `solutionType` come from the offer
 * response, not from the ui_json config_stepper snapshot.
 */
export const buildProfitabilityItemsFromState = (
  state: any,
  solutionCategory?: string,
  solutionType?: string,
) => {
  const asArray = (v: any) => (Array.isArray(v) ? v : []);

  if (!state?.cartBoq && !state?.dynamic) {
    return { saleItems: [], mpwItems: [], addOns: [], sisServices: [] };
  }

  const cartBoqSelector = state?.cartBoq;
  const dynamicSelector = state?.dynamic ?? { data: {} };
  const businessSelector = state?.business;
  const safeState = {
    ...state,
    dynamic: dynamicSelector,
    config_stepper: {
      data: {
        solution_form_data: { packages: {} },
        ...(state?.config_stepper?.data ?? {}),
      },
    },
  };

  const cartItems = cartBoqSelector?.data?.cart?.items
    ? _.cloneDeep(cartBoqSelector.data.cart.items)
    : [];

  const mpw = assembleMpwList(
    safeState,
    undefined,
    safeState.config_stepper,
    dynamicSelector,
    solutionCategory,
    solutionType,
    cartItems,
  );

  const allCartItems = cartBoqSelector?.data?.cart?.items || [];

  const findCartItemForGenerated = (item: any) => {
    const code = item.product_code || item.productCode;
    if (!code) return undefined;
    return allCartItems.find(
      (c: any) =>
        c.product_id === code ||
        c.productCode === code ||
        c.work_package === item.item_code ||
        (c.ootId && item.item_code === `${c.ootId}-${c.product_name}`),
    );
  };

  /** Enriches profitability payload items with duration, glp and cadPercent. */
  const applyPricingToItems = (items: any[]) =>
    items.map((item) => {
      const isRawBoqRow =
        !item.product_code &&
        !item.item_code &&
        (item.productCode || item.si_code || item.product_id);
      if (isRawBoqRow) {
        return applyPricing(item, {
          product_code: item.productCode || item.si_code || item.product_id,
          quantity: item.quantity,
          type: item.type,
        });
      }
      return applyPricing(findCartItemForGenerated(item) || {}, item);
    });

  if (!dynamicSelector?.data?.reference_solution) {
    return {
      saleItems: [],
      mpwItems: applyPricingToItems(asArray(mpw.mpwItems)),
      addOns: [],
      sisServices: [],
    };
  }

  const cartTotal = state?.caseDetails?.data?.total_boq_price ?? 0;
  const ndac = assembleNdacProtoType(
    cartBoqSelector,
    dynamicSelector,
    businessSelector,
    mpw.versionedBoQ_cartItems,
    cartTotal,
  );

  const getItemProductCode = (item: any) =>
    item?.product_code || item?.productCode || item?.product_id;

  const addOns = applyPricingToItems(asArray(ndac.protoType?.ndac_premium_addons));
  const addOnProductCodes = new Set(
    addOns.map(getItemProductCode).filter(Boolean),
  );
  const saleItems = applyPricingToItems(asArray(ndac.protoType?.boq)).filter(
    (item) => !addOnProductCodes.has(getItemProductCode(item)),
  );

  return {
    saleItems,
    mpwItems: applyPricingToItems(asArray(mpw.mpwItems)),
    addOns,
    sisServices: applyPricingToItems(asArray(ndac.protoType?.services)),
  };
};

/**
 * processServiceOnlyMpwSaleItemsForSyncOffer — enriches sale items with totalCost and
 * totalListPrice before the service-only sync-offer API call.
 */
export const processServiceOnlyMpwSaleItemsForSyncOffer = (saleItems: any[]) => {
  if (!Array.isArray(saleItems) || saleItems.length === 0) {
    return saleItems;
  }
  return saleItems.map((item) => {
    const qty = Number(item?.quantity) || 0;
    const effort = Number(item?.effort) || 0;
    const cost = Number(item?.cost) || 0;
    const listprice = item?.listprice != null ? Number(item.listprice) : 0;
    return {
      ...item,
      totalCost: qty * effort * cost,
      totalListPrice: qty * effort * listprice,
    };
  });
};


/**
 * buildOfferPayload — assembles the `offerList` and `dataProtoType` consumed
 * by createNewOffer / OOT.syncOffer. Holds termDeviation, bulkorder,
 * setStateOffer, setLeadProduct, dataProtoType assembly, and the help-segment
 * / accessToken pre-flight checks.
 *
 * Returns `earlyReturn` when the help-segment validation fails (the original
 * code returned `{ response_code: 0, response_msg }` from handleOffer in that
 * branch). Returns `abort: true` when accessToken is missing (the original
 * code returned `undefined` in that branch).
 */
const buildOfferPayload = (
  state: RootState,
  boq: ReturnType<typeof prepareBoq>,
  isServiceOnlySubType: boolean,
): {
  offerList: any;
  dataProtoType: any;
  earlyReturn?: { response_code: number; response_msg: string };
  abort?: boolean;
} => {
  const authSelector = state.authSlice;
  const caseDetailsSelector = state.caseDetails;
  const findCaseSelector = state.findCase;
  const businessSelector = state.business;
  const configSelector = state.config_stepper;
  const dynamicSelector = state.dynamic;
  const solutionCategory = configSelector.data.solutionCategory;
  const solutionType = configSelector.data.solutionType;

  const {
    config_mpw_params,
    configurator_mpw_list,
    protoType,
    contractDuration,
    isCustomized,
    lead_product,
  } = boq;

  if (isServiceOnlySubType && configurator_mpw_list?.items?.length > 0) {
    configurator_mpw_list.items = processServiceOnlyMpwSaleItemsForSyncOffer(
      configurator_mpw_list.items
    );
  }

  //nw_plan_id - odt planner id if available
  let offerList: any = {
    id: dynamicSelector.data?.offer_id ? dynamicSelector.data?.offer_id : "",
    name: caseDetailsSelector.data.caseName,
    shipping_country: caseDetailsSelector.data.shipping_country,
    sales_channel: caseDetailsSelector.data.sales_channel,
    end_customer: caseDetailsSelector.data.endCustomer,
    market: caseDetailsSelector.data.market,
    summary: caseDetailsSelector.data.summary,
    owner:
      authSelector.offer_owner_email?.length > 0
        ? authSelector.offer_owner_email
        : authSelector.login.mail,
    network_location: caseDetailsSelector.data.country,
    co_owner: caseDetailsSelector.data.co_owner,
    scrm_id: !sCRMRegex.test(findCaseSelector.data.sCRMID)
      ? "19.XY.123456"
      : findCaseSelector.data.sCRMID,
    public_funding_required: caseDetailsSelector.data.public_funding_required
      ? "yes"
      : "no",
    reason_for_funding: caseDetailsSelector.data.public_funding_required
      ? caseDetailsSelector.data.summary
      : "NA",
    case_type: findCaseSelector.data.caseType,
    case_sub_type: findCaseSelector.data.subType,
    customerSegmentId: businessSelector.data.options.PTDAC.caseIndustry,
    budgetary: caseDetailsSelector.data.caseCategory,
    lead_product: lead_product,
    commercial_model:
      findCaseSelector.data.subType === "help"
        ? businessSelector.data.view.PTDAC.commercial_model.toLowerCase()
        : caseDetailsSelector.data.commercial_model.toLowerCase(),
    contract_duration: contractDuration
      ? contractDuration
      : caseDetailsSelector.data.contract_duration,
    contracting_party_id: caseDetailsSelector.data.account,
    currency: caseDetailsSelector.data.currency,
    network_id: caseDetailsSelector.data.network_id,
    solution: configSelector.data.solution_selected,
    requested_state: "draft",
    validationDetails: dynamicSelector.data.validationDetails
      ? dynamicSelector.data.validationDetails["validateResponse"]
      : {},
    nw_plan_id: dynamicSelector.data.reference_solution
      ? dynamicSelector.data.reference_solution.linkedPlanner["sys_id"]
      : "",
    // isCustomized is set to true if the cart is customized
    isCustomized: isCustomized,
    sid: dynamicSelector.data.sid,
    ciq_mxie_version: getMXIEVersionValue(state, 'version'),
    dd_needed: getMXIEVersionValue(state, 'dd_needed')
  };
  const termDeviation =
    !caseDetailsSelector?.data?.termDeviation &&
      findCaseSelector?.data?.subType === "merchant_offer"
      ? false
      : caseDetailsSelector?.data?.termDeviation;
  // add this property when the termdeviation is set to true in the case details
  if (termDeviation !== undefined && termDeviation !== null) {
    offerList["termDeviation"] = termDeviation;
    offerList.requested_state = "draft";
    if (termDeviation) {
      offerList.requested_state = "pendingapproval";
      const est_date_months = 1;
      const reqDeli_date_months = 2;
      const datesData = getDateCalculated(
        est_date_months,
        reqDeli_date_months
      );
      offerList["estimated_order_date"] = datesData.final_est_order_date;
      offerList["requested_deli_date"] = datesData.final_req_delivery_date;
      offerList["nature_of_order"] = "internal";
    }
  }

  // set the bulk order and bulk order quantity in the offerList
  if (caseDetailsSelector?.data?.bulkorder !== undefined && caseDetailsSelector?.data?.bulkorder !== null) {
    // set bulk order details only when it is not null/undefined
    offerList["bulk_order"] =
      caseDetailsSelector.data.bulkorder === "Yes" ? true : false;
    // set bulk order quantity only when it is true
    if (offerList['bulk_order']) {
      offerList['no_of_networks'] = caseDetailsSelector.data.bulkOrderQuantity;
    }
  } else {
    // for other case types where bulkorder field itself not available set it to NA
    offerList["bulk_order"] = "NA";
  }

  setStateOffer(offerList, configurator_mpw_list, protoType, isServiceOnlySubType);

  offerList = setLeadProduct(config_mpw_params, configSelector, offerList);

  // set the offerList.requested_state to 'draft' if the cart is customized
  // --- Need to check if this is correct - on draft BoQ is coming from dashboard ?
  if (isCustomized) {
    offerList.requested_state = "draft";
  }

  // set ServiceOnly Subtype fileuploaded details to send to OOT
  if (isServiceOnlySubType === true) {
    const service_assets_id = dynamicSelector.data?.serviceOnlyAfterUploadedData?.id || "";
    const service_file_name = dynamicSelector.data?.serviceOnlyAfterUploadedData?.file_name || "";
    offerList.service_assets = { "id": service_assets_id, "file_name": service_file_name }
  }

  const dataProtoType =
    _.includes(["NDAC", "MPW"], solutionCategory) &&
      solutionType !== "Standalone"
      ? {
        offer: offerList,
        configurator_mpw: {
          ...configurator_mpw_list,
        },
        DAC_DATA: {
          ...protoType,
        },
        eot_services_response: {
          ...dynamicSelector.data.eot_response_syncoffer,
        },
      }
      : {
        offer: offerList,
        configurator_mpw: {
          ...configurator_mpw_list,
        },
      };

  // If the solution type is ndac_services_only, then we need to filter the sis services from the eot services response
  // and add them to the configurator_mpw items
  // and remove them from the DAC_DATA.services
  // and remove them from the DAC_DATA.boq
  // and remove them from the eot_services_response
  const isNdacServiceOnlySolutionType = configSelector?.data?.solution_selected === "ndac_services_only";
  if (
    isNdacServiceOnlySolutionType &&
    dataProtoType.DAC_DATA &&
    dataProtoType.configurator_mpw
  ) {
    const eotServicesResponse = _.cloneDeep(dataProtoType.eot_services_response);
    const dacServices = Array.isArray(dataProtoType.DAC_DATA.services)
      ? dataProtoType.DAC_DATA.services
      : [];
    const eotServicesList = Array.isArray(eotServicesResponse)
      ? eotServicesResponse
      : _.values(eotServicesResponse ?? {});
    
    // Map the eot services list to the ndac sis services list
    const ndac_sisServices = eotServicesList.map((eotItem) => {
      const matchedDac = dacServices.find((dacItem) => {
        return (
         eotItem.si_code === dacItem.item_code
        );
      });
      if (!matchedDac) {
        return eotItem;
      }
      return {
        ...eotItem,
        customAction: matchedDac.customAction,
        duration: matchedDac.duration,
        fxRate: matchedDac.fxRate,
        prevQuantity: matchedDac.prevQuantity,
        quantity: matchedDac.quantity,
        total_pnp_with_incoterm: matchedDac.price
      };
    });
    const dacBoq = dataProtoType.DAC_DATA.boq;
    const config_mpwItems = Array.isArray(dataProtoType.configurator_mpw.items)
      ? dataProtoType.configurator_mpw.items
      : [];
    const filteredSisServices = Array.isArray(dacBoq)
      ? _.filter(dacBoq, (boqItem) =>
          !_.some(
            ndac_sisServices,
            (sisService) => sisService?.si_code === boqItem?.product_code,
          ),
        )
      : dacBoq;
    
    dataProtoType.configurator_mpw = {
      ...dataProtoType.configurator_mpw,
      items: [...config_mpwItems, ...ndac_sisServices],
    };
    dataProtoType.DAC_DATA = {
      ...dataProtoType.DAC_DATA,
      services: [],
      boq: filteredSisServices,
    };
    dataProtoType.eot_services_response = {};
  }

  // Add the assumptions from dynamic selector to protoType which will be sent to OOT
  if (dynamicSelector.data?.element?.["assumptions"]?.["markup"]) {
    dataProtoType["assumptions"] = dynamicSelector.data?.element?.["assumptions"]?.["markup"];
  }
  // Add the validation message to the offer data
  dataProtoType["notification_messages"] = getSavedValidationMessageList();

  if (
    findCaseSelector.data.subType === "help" &&
    !businessSelector.data.options.PTDAC.caseIndustry
  ) {
    store.dispatch(
      setError({
        key: "error",
        value: {
          errorCode: null,
          errorMsg: "Please select a customer segment",
        },
      })
    );

    return {
      offerList,
      dataProtoType,
      earlyReturn: {
        response_code: 0,
        response_msg: "Please select a customer segment",
      },
    };
  }

  // Check if accessToken is available
  if (!authSelector.login.hasOwnProperty("accessToken")) {
    setError({
      key: "warn",
      value: {
        errorCode: null,
        errorMsg: "The accesstoken is not set,re-login is required.",
      },
    });
    return { offerList, dataProtoType, abort: true };
  }

  return { offerList, dataProtoType };
};

/**
 * handleServiceOnlyOffer — shows the loader/modal before invoking the offer
 * API. Service-only subtype on the "services" step uses the BoQ loader;
 * everything else uses the global loader + "Creating Offer" modal.
 */
const handleServiceOnlyOffer = (
  isServiceOnlySubType: boolean,
  activeStep: string
) => {
  // Show loader and modal for offer creation (skip for service-only subtypes)
  if (!isServiceOnlySubType || (isServiceOnlySubType && activeStep !== "services")) {
    store.dispatch(showLoader(true));
    store.dispatch(
      showModal({
        msg: "Offer creation in progress, Please wait..",
        title: "Creating Offer",
        show: true,
        variant: "WARNING",
      })
    );
  } else {
    store.dispatch(showBoqLoader(true));
  }
};

/**
 * postProcessing — handles success/failure UI updates after the offer API
 * call resolves. Branches by `kind`:
 *   - 'CREATE_PAGE' → success/error modal + optional redirect via [OFFER_ID]
 *     placeholder, then turns off the global loader.
 *   - 'OOT'         → cart/dynamic BoQ backup, datamart save, setLive, success
 *     modal + window.open redirect (or returns the offer_id when the action
 *     is gated by service-only subtype on the "services" step).
 */
const postProcessing = async (
  kind: "CREATE_PAGE" | "OOT",
  args: {
    responseData?: any;
    response?: any;
    payload_backend?: any;
    redirect: any;
    offerList: any;
    isServiceOnlySubType: boolean;
  }
) => {
  if (kind === "CREATE_PAGE") {
    const { responseData, redirect } = args;
    const offer_id = responseData?.response?.result?.offer_id || "";
    if (responseData?.response_code === 1) {
      const redirectUrl = redirect?.url;
      let message = "";
      if (redirect?.isValid === true && redirectUrl) {
        message = `Offer: ${offer_id} created successfully.`;
      } else {
        message = `The offer (ID: ${offer_id}) was created successfully. 
          However, redirection could not be completed because the configured redirect URL is invalid. 
          Please review and update the redirect URL settings.`;
      }
      // Show success modal
      store.dispatch(
        showModal({
          msg: message,
          title: `Offer ${offer_id} successfully created.`,
          show: true,
        })
      );
      if (redirect?.isValid === true) {
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // Replace [OFFER_ID] placeholder with actual offer_id
        const _redirect_to = redirectUrl.includes("[OFFER_ID]")
          ? redirectUrl.replace("[OFFER_ID]", offer_id)
          : `${redirectUrl}${offer_id}`;
        window.open(_redirect_to, "_top");
      }
    } else {
      store.dispatch(
        showModal({
          msg: responseData.response_msg || "Failed to create offer.",
          title: "Something went wrong",
          show: true,
          variant: "ERROR",
        })
      );
    }
    store.dispatch(showLoader(false));
    return;
  }

  if (kind === "OOT") {
    const { response, payload_backend, redirect, offerList, isServiceOnlySubType } = args;
    // **customiseboq** after offer is created , make cartboq_backup same as cartboq and dynamicBoq_backup same as dynamic boq
    store.getState().cartBoq?.data?.cart?.items?.length > 0 &&
      store.dispatch(
        setProp({
          slice: "cartBoq",
          key: "cartBakup",
          value: store.getState().cartBoq?.data?.cart,
        })
      );
    store.getState().dynamic?.data?.boq.length > 0 &&
      store.dispatch(
        setProp({
          slice: "dynamic",
          key: "dynamicboqBakup",
          value: store.getState().dynamic?.data?.boq,
        })
      );
    // send the all data , offer id and syncoffer payload to datamart as POST. New entry has to be added with different temp_offer_id and offer_id
    const aftersyncoffer_data = {
      offerid: response.result?.offer_id,
      payload: payload_backend,
      leadProduct: offerList?.lead_product,
      profitabilityDelete: Boolean(offerList?.id),
    };
    const isActionAllowed = !isServiceOnlySubType || (isServiceOnlySubType && store.getState().config_stepper.data.active_step !== "services");
    // Call the /offer API only when the subtype is not service-only
    const selectors = {
      caseSelector: store.getState().caseDetails,
      dynamicSelector: store.getState().dynamic,
      findSelector: store.getState().findCase,
      configStepperSelector: store.getState().config_stepper,
      authSelector: store.getState().authSlice,
    };
    if (isActionAllowed) {
      await DATAMART_SERVICES.saveCartDetails_service(
        selectors,
        aftersyncoffer_data
      );
    }
    store.dispatch(setLive(true));
    if (isActionAllowed) {
      store.dispatch(
        showModal({
          msg: `Offer: ${response.result?.offer_id} created`,
          title: `Offer ${response.result?.offer_id} successfully created.`,
          show: true,
        })
      );
      await new Promise((resolve) => setTimeout(resolve, 3000));
      window.open(
        redirect.urlPrefix +
        response.result?.offer_id +
        "&cui_login=ms",
        "_top"
      );
      return;
    } else {
      return { response_code: 1, offer_id: response.result?.offer_id };
    }
    //return { response_code: 1, response_msg: response.data }
    //  setTimeout(()=>handleRestLogic(),4000)
  }
};

/**
 * executeOfferAPI — invokes the appropriate offer API and delegates success
 * UI handling to `postProcessing`. CREATE_PAGE → createNewOffer; CONFIGURATION
 * → either OOT.syncOffer (id === "OOT") or the EOT/ENSO redirect chain
 * (id === "ENSO"). The ENSO branch is largely a redirect-only flow with its
 * own validation chain and stays inline here.
 */
const executeOfferAPI = async (
  state: RootState,
  context: string,
  redirect: any,
  dataProtoType: any,
  offerList: any,
  isServiceOnlySubType: boolean
) => {
  const authSelector = state.authSlice;
  const caseDetailsSelector = state.caseDetails;
  const findCaseSelector = state.findCase;
  const businessSelector = state.business;

  if (context === "CREATE_PAGE") {
    // Create Offer
    const responseData = await createNewOffer(dataProtoType, offerList);
    return await postProcessing("CREATE_PAGE", {
      responseData,
      redirect,
      offerList,
      isServiceOnlySubType,
    });
  } else {
    if (redirect.hasOwnProperty("id")) {
      switch (redirect.id) {
        case "OOT":
          // store.dispatch(showLoader(true));
          // store.dispatch(
          //   showModal({
          //     msg: "Offer creation in progress, Please wait..",
          //     title: "Creating Offer",
          //     show: true,
          //     variant: "WARNING",
          //   })
          // );
          // if (!authSelector.login.hasOwnProperty("accessToken")) {
          //   setError({
          //     key: "warn",
          //     value: {
          //       errorCode: null,
          //       errorMsg: "The accesstoken is not set,re-login is required.",
          //     },
          //   });
          //   return;
          // }

          try {
            // Find and update the items customAction field = CUSTOM_ACTIONS.NEW_ITEM
            // for all the items wehose type === "custom_add_service" Or type === "custom_add_product"
            // as per story : ECE_COMOPS-14060
            dataProtoType?.configurator_mpw?.items?.forEach((eachItem) => {
              if ((eachItem.workPackage === "custom_item" || eachItem.type === "custom_add_service" || eachItem.type === PRODUCT_TYPE_SERVICE_ONLY) && eachItem['customAction'] !== CUSTOM_ACTIONS.DELETED) {
                eachItem['customAction'] = CUSTOM_ACTIONS.NEW_ITEM;
              }
            });

            const responseData = await OOT.syncOffer({
              data: dataProtoType,
            });
            const response = responseData.data[0];
            const payload_backend = responseData.data[1];

            store.dispatch(showLoader(false));
            store.dispatch(showBoqLoader(false));
            if (response.status) {
              return await postProcessing("OOT", {
                response,
                payload_backend,
                redirect,
                offerList,
                isServiceOnlySubType,
              });
            } else {
              store.dispatch(
                showModal({
                  msg: response.errorMessage,
                  title: "Something went wrong",
                  show: true,
                  variant: "ERROR",
                })
              );
              return {
                response_code: 0,
                response_msg: response.errorMessage,
              };
            }
          } catch (err) {
            console.log("error :", err);
            let errorMsg = "Something went wrong";
            if (err?.response?.status && err?.message) {
              errorMsg = err.response.status + ":" + err.message;
            }
            store.dispatch(
              showModal({
                msg: errorMsg,
                title: "Server Error",
                show: true,
                variant: "ERROR",
              })
            );
            store.dispatch(setLive(false));
          }

          break;
        case "ENSO":
          var endCust = await OOT.getAccountCustomer({
            account_nid: caseDetailsSelector.data.endCustomer_account_nid
              ? caseDetailsSelector.data.endCustomer_account_nid
              : caseDetailsSelector.data.account,
          });
          if (!endCust?.status) {
            store.dispatch(
              setError({
                key: "error",
                value: {
                  errorCode: null,
                  errorMsg: `Failed to  get Customers for ${caseDetailsSelector.data.account}`,
                },
              })
            );
            return {
              response_code: 0,
              response_msg: "Failed to find three_star_acc_id name",
            };
          }
          if (endCust?.data?.accounts?.length === 0) {
            store.dispatch(
              setError({
                key: "error",
                value: {
                  errorCode: null,
                  errorMsg: `0 Customers found for the selected account, try again.`,
                },
              })
            );
            return {
              response_code: 0,
              response_msg: "Failed to find three_star_acc_id name",
            };
          }
          //let three_star_acc = endCust?.data?.customers.find((c) => c.name == authSelector.system.account[0].value)
          let three_star_acc_id = endCust?.data?.accounts[0]["3*_number"];
          if (!three_star_acc_id) {
            store.dispatch(
              setError({
                key: "error",
                value: {
                  errorCode: null,
                  errorMsg: `Exception: 3 star id for account is empty, try again.`,
                },
              })
            );
            return {
              response_code: 0,
              response_msg: "Failed to find three_star_acc_id name",
            };
          }
          store.dispatch(showLoader(false));
          // dispatch(setError(null));
          if (true) {
            if (!sCRMRegex.test(findCaseSelector.data.sCRMID)) {
              store.dispatch(
                setError({
                  key: "warn",
                  value: {
                    errorCode: null,
                    errorMsg:
                      "Empty or invalid sCRM will not work for MPW-S cases",
                  },
                })
              );
              return;
            }
            // if (caseDetailsSelector.data.caseCategory === "Budgetary") {
            //   //const loginMSALAuth =`https://login.microsoftonline.com/${toolRedirect.ENSO.tenantID}/ oauth2/v2.0/authorize?scope=User.Read&response_type=code&client_id=${proces}&redirect_uri=https://iesp.cloud-test.nokia.com/auth_oauth/Microsoft&state=`

            //   if (authSelector.role === ROLE.INTERNAL) {
            //     window.open(generateEOTRedirect(redirect.homePage), "_self");
            //   }
            //   if (authSelector.role === ROLE.PARTNER) {
            //     window.open(
            //       generateEOTRedirect(redirect.homePagePartner),
            //       "_self"
            //     );
            //   }
            //   handleRestLogic();
            //   return { response_code: 1, response_msg: 'Redirected to EOT' };
            // }

            // Unused variable decodedEndCustomer, need to check if we need to use this or not,
            // let decodedEndCustomer = undefined;
            // if (
            //   caseDetailsSelector.data.sales_channel === "DIR" &&
            //   authSelector.OOT?.data?.end_customer?.name
            // ) {
            //   decodedEndCustomer = authSelector.OOT.data.end_customer.name;
            // } else {
            //   const search = authSelector.system.endCustomer.find(
            //     (z) => z.id === caseDetailsSelector.data.endCustomer
            //   );
            //   decodedEndCustomer = search.value;
            // }

            // new implementation - change endcustomer to account: 21-11-23
            const searchAccount = authSelector.system.account.find(
              (z) => z.id === caseDetailsSelector.data.account
            );
            const decodedEndAccount = searchAccount.value;
            // Varibale is defined but not used, need to check if we need to use this or not,
            // const endCustomerData = authSelector.system.endCustomer.find(
            //   (e) => e.id === caseDetailsSelector.data.endCustomer
            // );
            if (decodedEndAccount === undefined) {
              store.dispatch(
                setError({
                  key: "error",
                  value: {
                    errorCode: null,
                    errorMsg: "Failed to find account name",
                  },
                })
              );
              return {
                response_code: 0,
                response_msg: "Failed to find account name",
              };
            }
            // Unused variable decodedEndCustomer, need to check if we need to use this or not,
            // const base64Customer = encodeBase64(decodedEndCustomer);
            // const base64Account = encodeBase64(decodedEndAccount);
            const scrmid = findCaseSelector.data.sCRMID.toUpperCase();
            if (authSelector.role === ROLE.INTERNAL) {
              const urlParms = `?case_type=${findCaseSelector.data.caseType
                }&case_sub_type=${findCaseSelector.data.subType
                }&opportunity_id=${scrmid}&segment_id=${businessSelector.data.options.PTDAC.caseIndustry ===
                  "reference_solution"
                  ? "ndac_reference_solution"
                  : businessSelector.data.options.PTDAC.caseIndustry
                }&3_star_number=${three_star_acc_id}`;
              //  window.location.href = redirect.urlPrefix + urlParms;
              const encodedState = encodeBase64(urlParms);
              const url = redirect.urlPrefix + "?state=" + encodedState;
              window.open(generateEOTRedirect(url), "_self");
              handleRestLogic();
              return { response_code: 1, response_msg: "Redirected to EOT" };
            }
            if (authSelector.role === ROLE.PARTNER) {
              const urlParms = `?case_type=${findCaseSelector.data.caseType}&case_sub_type=${findCaseSelector.data.subType}&opportunity_id=${scrmid}&segment_id=${businessSelector.data.options.PTDAC.caseIndustry}`;
              //  window.location.href = redirect.urlPrefixPartner + urlParms;
              const encodedState = encodeBase64(urlParms);
              const url =
                redirect.urlPrefixPartner + "?state=" + encodedState;
              window.open(generateEOTRedirect(url), "_self");
              handleRestLogic();
              return { response_code: 1, response_msg: "Redirected to EOT" };
            }
          }
          break;
        default:
          break;
      }
    }
  }
};

export const handleOffer = async (
  state: RootState,
  getListOfFields = undefined || {},
  context = "CREATE_PAGE",
) => {
  const authSelector = state.authSlice;
  const caseDetailsSelector = state.caseDetails;
  const findCaseSelector = state.findCase;
  const businessSelector = state.business;
  const cartBoqSelector = state.cartBoq;

  const cartTotal = totalCost(state.cartBoq);
  const configSelector = state.config_stepper;
  const dynamicSelector = state.dynamic;

  const solutionCategory = configSelector.data.solutionCategory;
  const solutionType = configSelector.data.solutionType;

  // Get selected case type and subtype
  const caseType = findCaseSelector.data.caseType;
  const subType = findCaseSelector.data.subType;
  const isServiceOnlySubType = findCaseSelector.data?.isServiceOnlySubType && findCaseSelector.data?.isServiceOnlySubType === true ? true : false;
  // Get selected sub type object from caseSubTypes
  const caseTypeObj = findCaseSelector?.caseList?.data?.find(
    (ct) => ct.code === caseType
  );
  const subTypeObj =
    caseTypeObj?.sub_types?.find((st) => st.code === subType) || undefined;
  // Handle the exception case type
  if (!caseTypeObj || !subTypeObj) {
    console.warn(
      "Error : Looks like Casetype or subtype is not selected",
      caseTypeObj,
      subTypeObj
    );
    store.dispatch(
      setRedirectModal({
        isOpen: true,
        message: "Looks like Casetype or subtype is not selected",
      })
    );
    return;
  }

  try {
    // 1. Resolve initial redirect (CREATE_PAGE vs CONFIGURATION).
    let redirect =
      context === "CREATE_PAGE"
        ? handleRedirectOnCreate(subTypeObj)
        : handleRedirectType(state);

    // 2. Build BoQ-related variables (configurator_mpw_list, protoType,
    //    versionedBoQ_cartItems, lead_product, contractDuration, etc.).
    //    May update `redirect` for CONFIGURATION ctx (MPW redirect override).
    const boq = prepareBoq(
      state,
      getListOfFields,
      context,
      redirect,
      isServiceOnlySubType
    );
    redirect = boq.redirect;

    // 3. Assemble offerList + dataProtoType. Also performs the help-segment
    //    and accessToken pre-flight checks (via earlyReturn / abort).
    const payload = buildOfferPayload(state, boq, isServiceOnlySubType);
    if (payload.earlyReturn) return payload.earlyReturn;
    if (payload.abort) return;

    // 4. Show the appropriate loader/modal for offer creation.
    handleServiceOnlyOffer(
      isServiceOnlySubType,
      configSelector.data.active_step
    );

    // 5. Invoke the offer API (createNewOffer or OOT.syncOffer or ENSO redirect).
    //    postProcessing is invoked from inside for CREATE_PAGE / OOT branches.
    return await executeOfferAPI(
      state,
      context,
      redirect,
      payload.dataProtoType,
      payload.offerList,
      isServiceOnlySubType
    );
  } catch (error) {
    store.dispatch(setStatus(STATUS.ERROR));
    setError({
      key: "error",
      value: { errorMsg: error, errorCode: null },
    });
  }
};

/**
 * createNewOffer - function to create new offer by calling OOT syncOffer API
 *
 * @param data
 * @param offerList
 * @returns Object with response_code, response_msg and response`
 */
const createNewOffer = async (data, offerList) => {
  try {
    const responseData = await OOT.syncOffer({ data });
    const response = responseData.data[0];
    const payload_backend = responseData.data[1];

    if (response.status) {
      // **customiseboq** after offer is created , make cartboq_backup same as cartboq and dynamicBoq_backup same as dynamic boq
      store.getState().cartBoq?.data?.cart?.items?.length > 0 &&
        store.dispatch(
          setProp({
            slice: "cartBoq",
            key: "cartBakup",
            value: store.getState().cartBoq?.data?.cart,
          })
        );
      store.getState().dynamic?.data?.boq.length > 0 &&
        store.dispatch(
          setProp({
            slice: "dynamic",
            key: "dynamicboqBakup",
            value: store.getState().dynamic?.data?.boq,
          })
        );
      // send the all data , offer id and syncoffer payload to datamart as POST. New entry has to be added with different temp_offer_id and offer_id
      const aftersyncoffer_data = {
        offerid: response.result?.offer_id,
        payload: payload_backend,
        leadProduct: offerList?.lead_product,
        profitabilityDelete: false,
      };
      const selectors = {
        caseSelector: store.getState().caseDetails,
        dynamicSelector: store.getState().dynamic,
        findSelector: store.getState().findCase,
        configStepperSelector: store.getState().config_stepper,
        authSelector: store.getState().authSlice,
      };

      await DATAMART_SERVICES.saveCartDetails_service(
        selectors,
        aftersyncoffer_data
      );

      return { response_code: 1, response_msg: "", response };
    } else {
      return {
        response_code: 0,
        response_msg: response.errorMessage,
        result: response,
      };
    }
  } catch (err) {
    let errorMsg = "Something went wrong";
    if (err?.response?.status && err?.message) {
      errorMsg = err.response.status + ":" + err.message;
    }
    return { response_code: 0, response_msg: errorMsg };
  }
};

const setStateOffer = (offerList, configurator_mpw_list, protoType, isServiceOnlySubType) => {
  // set requested_state to approved when only mpw items are there and there are no ndac items
  if (
    configurator_mpw_list["items"] &&
    configurator_mpw_list["items"].length > 0 &&
    (_.isEmpty(protoType) || protoType["boq"].length === 0)
  ) {
    //  as per discussion serviceonly should be sent as draft state always for serviceonlyMpw
    if (isServiceOnlySubType === true) {
      offerList.requested_state = "draft";
    } else {
      offerList.requested_state = "approved";
    }
  }
};

const setLeadProduct = (config_mpw_params, configSelector, offerList) => {
  if (Object.keys(config_mpw_params).length > 0) {
    if (offerList?.case_sub_type === "help") {
      offerList["lead_product"] = "NDAC";
      // for both CMU and MPW
      if (_.includes(["MPW"], configSelector.data.solutionCategory)) {
        offerList["lead_product"] = "MPW";
      } else if (
        configSelector.data.solutionCategory === "NDAC" &&
        configSelector.data.solution_selected === "ndac_compact"
      ) {
        offerList["lead_product"] = "ndac_compact";
      }
    }
    offerList = { ...offerList, ...config_mpw_params };
  }
  return offerList;
};

const getDateCalculated = (
  estimationMonths = undefined,
  reqDeliMonths = undefined
) => {
  const est_order_addMonths =
    estimationMonths !== undefined ? estimationMonths : 2;
  const req_delivery_addMonths =
    reqDeliMonths !== undefined ? reqDeliMonths : 6;

  // estimated date will be current date + 2 months
  let current_est_date = new Date();
  current_est_date.setMonth(current_est_date.getMonth() + est_order_addMonths);
  const est_order_date = current_est_date.getMonth() + 1;
  const estyear = current_est_date.getFullYear();
  const estdate = current_est_date.getDate();

  // requested date will be current date + 6 months
  let current_req_date = new Date();
  current_req_date.setMonth(
    current_req_date.getMonth() + req_delivery_addMonths
  );
  const req_delivery_date = current_req_date.getMonth() + 1;
  const reqyear = current_req_date.getFullYear();
  const reqdate = current_req_date.getDate();

  const est_order_month =
    est_order_date < 10 ? "0" + est_order_date : "" + est_order_date;
  const req_delivery_month =
    req_delivery_date < 10 ? "0" + req_delivery_date : "" + req_delivery_date;

  const finalestdate = estdate < 10 ? "0" + estdate : "" + estdate;
  const finalreqdate = reqdate < 10 ? "0" + reqdate : "" + reqdate;

  const est = `${estyear}-${est_order_month}-${finalestdate}`;
  const req_delivery = `${reqyear}-${req_delivery_month}-${finalreqdate}`;

  return { final_est_order_date: est, final_req_delivery_date: req_delivery };
};

/**
 * Get the saved validation message list from the dynamic store.
 *
 * @returns {Array} - The list of saved validation messages.
 */

const getSavedValidationMessageList = () => {
  // Get the current state
  const reduxStore = store.getState();
  const dynamicSelector = reduxStore.dynamic;
  // Ensure safe access by providing empty arrays as defaults
  const notificationMessages = dynamicSelector?.data?.notification_messages;
  let result = [];
  // Traverse the object and extract the warning and information messages
  function traverse(node) {
    if (Array.isArray(node)) {
      node.forEach((item) => {
        if (item.type === "warning" || item.type === "information") {
          result.push(item);
        }
      });
    } else if (typeof node === "object" && node !== null) {
      Object.values(node).forEach(traverse);
    }
  }

  // If there are no messages, return an empty array
  if (_.isEmpty(notificationMessages)) {
    return [];
  }
  // Call the recursive function
  traverse(notificationMessages);
  return result;
};

export const fetchAccountData = async (state: RootState) => {
  const caseDetailsSelector = state.caseDetails;
  const account_nid_value = caseDetailsSelector.data.endCustomer_account_nid
    ? caseDetailsSelector.data.endCustomer_account_nid
    : caseDetailsSelector.data.account;

  var endCust = await OOT.getAccountCustomer({
    account_nid: account_nid_value,
  });
  if (!endCust?.status) {
    store.dispatch(
      setError({
        key: "error",
        value: {
          errorCode: null,
          errorMsg: `Failed to  get Customers for ${caseDetailsSelector.data.account}`,
        },
      })
    );
    return {
      response_code: 0,
      response_msg: "Failed to find three_star_acc_id name",
    };
  }
  if (endCust?.data?.accounts?.length === 0) {
    store.dispatch(
      setError({
        key: "error",
        value: {
          errorCode: null,
          errorMsg: `0 Customers found for the selected account, try again.`,
        },
      })
    );
    return {
      response_code: 0,
      response_msg: "Failed to find three_star_acc_id name",
    };
  }
  let three_star_acc_id = endCust?.data?.accounts[0]["3*_number"];
  if (!three_star_acc_id) {
    store.dispatch(
      setError({
        key: "error",
        value: {
          errorCode: null,
          errorMsg: `Exception: 3 star id for account is empty, try again.`,
        },
      })
    );
    return {
      response_code: 0,
      response_msg: "Failed to find three_star_acc_id name",
    };
  } else {
    const accountName = endCust?.data?.accounts[0]["name"];
    const account_one_star_number = endCust?.data?.accounts[0]["1*_number"];
    store.dispatch(setOBJ({ path: "account_name", value: accountName }));
    store.dispatch(
      setOBJ({ path: "three_star_number", value: three_star_acc_id })
    );
    store.dispatch(
      setOBJ({
        path: "account_one_star_number",
        value: account_one_star_number,
      })
    );
  }
};

export const ndac_fetchSlaWarrantyProducts = (cartBoqSelector, dynamicSelector, businessSelector, versionedBoQ_cartItems) => {
  // const slaInput = dynamicSelector?.data?.element?.sla_warranty ? dynamicSelector?.data?.element?.sla_warranty : dynamicSelector?.data?.element?.care_srs_sla_warranty;

  // Take warranty and sla products from cartBoQ Selector as they are the latest BoQ
  let slaWarrantyProds = [];
  /* Special rule for NDAC Compact : No warranty and SLA products to be sent in ndac_premium_addons
  SLA item has to be sent in ndac_items , as at oot end this will be added in ndac items and addons will 
  be added automatically by OOT */
  if (dynamicSelector.data.reference_solution.commercial_model !== "operating_lease") {
    slaWarrantyProds = _.filter(cartBoqSelector?.data?.cart.items, (obj) => (
      obj.type === 'warranty' ||
      obj.category === 'warranty') ||
      (
        obj.category === 'sla' ||
        obj.type === 'sla' ||
        isHardwareSLAItem(obj)
      ));
  }

  // Filter SLA/warranty items from dynamic BOQ that are modified or deleted
  const modifiedOrDeletedSlaWarrantyItems = _.filter(versionedBoQ_cartItems, (obj) => {
    const isSlaOrWarranty = (
      obj.type === 'warranty' ||
      obj.category === 'warranty' ||
      obj.category === 'sla' ||
      obj.type === 'sla' ||
      isHardwareSLAItem(obj)
    );
    const isModifiedOrDeleted = (obj.customAction === CUSTOM_ACTIONS.MODIFIED || obj.customAction === CUSTOM_ACTIONS.DELETED);
    return isSlaOrWarranty && isModifiedOrDeleted;
  });

  // Merge modified/deleted items from dynamic BOQ with cart items
  if (modifiedOrDeletedSlaWarrantyItems.length > 0) {
    modifiedOrDeletedSlaWarrantyItems.forEach(dynamicItem => {
      // Check if this item already exists in slaWarrantyProds from cart
      const existingItemIndex = _.findIndex(slaWarrantyProds, (cartItem) => cartItem.product_id === dynamicItem.productCode);
      if (existingItemIndex !== -1) {
        // Item exists in cart, update it with customAction
        slaWarrantyProds[existingItemIndex]["customAction"] = dynamicItem.customAction;
        slaWarrantyProds[existingItemIndex]["prevQuantity"] = dynamicItem.prevQuantity;
        slaWarrantyProds[existingItemIndex]["quantity"] = dynamicItem.quantity;
      } else {
        // Item doesn't exist in cart, add it from dynamic BOQ
        const mappedItem = {
          product_id: dynamicItem.productCode,
          quantity: dynamicItem.quantity,
          type: dynamicItem.type,
          category: dynamicItem.category,
          duration: dynamicItem.duration,
          customAction: dynamicItem.customAction,
          prevQuantity: dynamicItem.prevQuantity
        };
        slaWarrantyProds.push(mappedItem);
      }
    });
  }

  const addonArray = [];

  slaWarrantyProds.forEach(eachProd => {
    let typename = 'support';
    let durationValue = businessSelector.data.view.PTDAC.commercial_model === "capex" ? eachProd.duration * 12 : eachProd.duration;
    if (eachProd.category === 'warranty' || eachProd.type === 'warranty') {
      typename = 'warranty';
      durationValue = eachProd.duration
    }

    // Set the duration  and type for For HW SLA sale items
    if (isHardwareSLAItem(eachProd)) {
      typename = "sla";
      durationValue = eachProd.duration;
    }

    const prodObj = {
      product_code: eachProd.product_id,
      quantity: eachProd.quantity,
      duration: durationValue,
      type: typename,
    };
    if (businessSelector.data.view.PTDAC.commercial_model === "capex") {
      // prodObj["extended_years"] = slaInput.extend_warranty_by ? slaInput.extend_warranty_by.value : "NA"
      prodObj["extended_years"] = prodObj.duration ? prodObj.duration : "NA";
    } else {
      // prodObj["extended_month"] = slaInput.extend_warranty_by ? slaInput.extend_warranty_by.value * 12 : "NA"
      prodObj["extended_month"] = prodObj.duration ? prodObj.duration : "NA";
    }

    // Add customAction and prevQuantity if they exist
    if (eachProd.customAction) {
      prodObj["customAction"] = eachProd.customAction;
    }
    if (eachProd.prevQuantity !== undefined && eachProd.prevQuantity !== null) {
      prodObj["prevQuantity"] = eachProd.prevQuantity;
    }

    addonArray.push(prodObj);
  });
  return addonArray;
};

export const identifySolutionRedirect = (combinations) => {
  // for CDM UG MPW redirect to EOT
  if (
    combinations.includes(fullMiningType.byIds.underground.id) &&
    combinations.includes(fullSolType.byIds.mpw.id)
  ) {
    return { next: false, redirect: toolRedirect.ENSO }; //"redirect_mpw"
  }
  return { next: true, redirect: null };
};

export const identifyMPWRedirect = (combinations) => {
  // for the selected solution if type is not NDAC then redirect to EOT
  if (!combinations.includes(fullSolType.byIds.ndac.value)) {
    return { next: false, redirect: toolRedirect.ENSO }; //"redirect_mpw"
  }
  return { next: true, redirect: null };
};
